export default "__VITE_ASSET__7ec93fc0__"